(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1087],{

/***/ 601523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ ArrowCouple; },
  "e": function() { return /* binding */ ArrowIcon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/ArrowIcons.tsx



var getBorderRadiusAccToShape = function(shape) {
    switch(shape){
        case "circular":
            return "18";
        case "square":
            return "0";
        case "rounded":
            return "5";
    }
};
function ArrowRightV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "36",
                fill: props.bgColor || "#fff",
                opacity: typeof props.bgOpacity === "number" ? props.bgOpacity : 0.4,
                rx: getBorderRadiusAccToShape(props.iconShape),
                transform: "matrix(-1 0 0 1 36 0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_112_2612)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    stroke: props.arrowColor || "#fff",
                    strokeWidth: "1.5",
                    d: "M15.578 11.828l5.819 5.818-5.819 5.819"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_112_2612",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20.571",
                        height: "20.571",
                        fill: "#fff",
                        rx: "10.286",
                        transform: "matrix(0 1 1 0 7.7 7.713)"
                    })
                })
            })
        ]
    }));
}
function ArrowLeftV1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 36 36"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "36",
                fill: props.bgColor || "#fff",
                opacity: typeof props.bgOpacity === "number" ? props.bgOpacity : 0.4,
                rx: getBorderRadiusAccToShape(props.iconShape)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_112_2596)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    stroke: props.arrowColor || "#fff",
                    strokeWidth: "1.5",
                    d: "M20.422 11.828l-5.819 5.818 5.819 5.819"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_112_2596",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20.571",
                        height: "20.571",
                        x: "28.301",
                        y: "7.713",
                        fill: "#fff",
                        rx: "10.286",
                        transform: "rotate(90 28.3 7.713)"
                    })
                })
            })
        ]
    }));
}
function ArrowRightV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "24",
        fill: "none",
        viewBox: "0 0 36 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#fff",
                opacity: "0.2",
                rx: getBorderRadiusAccToShape(props.iconShape),
                transform: "matrix(-1 0 0 1 36 0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#D9D9D9",
                d: "M19.417 16.333L24 11.667l-4.583 4.666zM24 11.667L19.417 7 24 11.667zm0 0H13h11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                d: "M19.417 16.333L24 11.667m0 0L19.417 7M24 11.667H13"
            })
        ]
    }));
}
function ArrowLeftV2(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "24",
        fill: "none",
        viewBox: "0 0 36 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#fff",
                opacity: "0.2",
                rx: getBorderRadiusAccToShape(props.iconShape)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#D9D9D9",
                d: "M16.583 16.333L12 11.667l4.583 4.666zM12 11.667L16.583 7 12 11.667zm0 0h11-11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                d: "M16.583 16.333L12 11.667m0 0L16.583 7M12 11.667h11"
            })
        ]
    }));
}
function ArrowLeftV3(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_d_255_271)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        filter: "url(#filter1_d_255_271)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "7",
                            y: "5",
                            width: "36",
                            height: "36",
                            rx: getBorderRadiusAccToShape(props.iconShape),
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "clip-path": "url(#clip0_255_271)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M27.4159 16.83L21.5974 22.6484L27.4159 28.4669",
                            stroke: "#111C36",
                            "stroke-width": "2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_d_255_271",
                        x: "0",
                        y: "0",
                        width: "50",
                        height: "50",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "3.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_255_271"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_255_271",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_d_255_271",
                        x: "5.5",
                        y: "3.5",
                        width: "39",
                        height: "39",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "0.75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0666667 0 0 0 0 0.109804 0 0 0 0 0.211765 0 0 0 0.2 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_255_271"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_255_271",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_255_271",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            x: "35.2891",
                            y: "12.7168",
                            width: "20.5714",
                            height: "20.5714",
                            rx: "10.2857",
                            transform: "rotate(90 35.2891 12.7168)",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(798388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Arrows/index.tsx





var ArrowIcon = function(props) {
    var _onClick = props.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _imageProps = props.imageProps, imageProps = _imageProps === void 0 ? {} : _imageProps, arrowDirection = props.arrowDirection, arrowType = props.arrowType;
    var Element = null;
    var _imageProps1 = (0,_object_spread/* default */.Z)({
        height: 36,
        width: 36,
        style: {},
        className: "",
        bgColor: "",
        bgOpacity: "",
        arrowColor: "",
        isShadowTypeIcon: false
    }, imageProps);
    var addShadow = _imageProps1.isShadowTypeIcon;
    switch(arrowType){
        case "v1":
            Element = arrowDirection === "left" ? ArrowLeftV1 : ArrowRightV1;
            break;
        case "v2":
            Element = arrowDirection === "left" ? ArrowLeftV2 : ArrowRightV2;
            break;
        case "v3":
            Element = ArrowLeftV3;
            break;
        default:
            Element = null;
    }
    if (!Element) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,bundle_mjs/* twMerge */.m6)("tw-pointer-events-auto tw-cursor-pointer", _imageProps1.className, addShadow ? " tw-inline-block " : ""),
        style: {
            height: imageProps.height,
            width: imageProps.width,
            filter: addShadow ? "drop-shadow(0 4px 10px #00000029)" : ""
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread/* default */.Z)({}, _imageProps1))
    });
};
var ArrowCouple = function(param) {
    var _handleNextClick = param.handleNextClick, handleNextClick = _handleNextClick === void 0 ? function() {} : _handleNextClick, _handlePrevClick = param.handlePrevClick, handlePrevClick = _handlePrevClick === void 0 ? function() {} : _handlePrevClick, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, _arrowType = param.arrowType, arrowType = _arrowType === void 0 ? "v1" : _arrowType, _className = param.className, className = _className === void 0 ? "" : _className, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass, _imageProps = param.imageProps, imageProps = _imageProps === void 0 ? {} : _imageProps, _style = param.style, style = _style === void 0 ? {} : _style;
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: style,
        className: classnames_default()("tw-absolute tw-top-[50%] tw-flex tw-w-[100%] tw-translate-y-[-50%] tw-items-center tw-justify-between tw-px-[40px]", className, containerClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                onClick: handlePrevClick,
                arrowDirection: "left",
                arrowType: arrowType,
                imageProps: imageProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                onClick: handleNextClick,
                arrowDirection: "right",
                arrowType: arrowType,
                imageProps: imageProps
            })
        ]
    });
};


/***/ }),

/***/ 51087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ChevronType1": function() { return /* binding */ ChevronType1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(999534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(932970);
/* harmony import */ var _ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(798388);
/* harmony import */ var _Arrows__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(601523);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(826910);









function ChevronType1(_param) {
    var showArrows = _param.showArrows, showChevrons = _param.showChevrons, handlePrevClick = _param.handlePrevClick, handleNextClick = _param.handleNextClick, chevronAnimationTiming = _param.chevronAnimationTiming, arrowPosition = _param.arrowPosition, _containerClass = _param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass, _showGradient = _param.showGradient, showGradient = _showGradient === void 0 ? false : _showGradient, _arrowStyle = _param.arrowStyle, arrowStyle = _arrowStyle === void 0 ? {} : _arrowStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "showArrows",
        "showChevrons",
        "handlePrevClick",
        "handleNextClick",
        "chevronAnimationTiming",
        "arrowPosition",
        "containerClass",
        "showGradient",
        "arrowStyle"
    ]);
    var progressContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var progressElementsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({});
    var isMobile = (0,src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_3__/* .isMobileDevice */ .s)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.isAutoPlayOn) {
            var progress = Object.values(progressElementsRef.current);
            var playNext = function(e) {
                var ref;
                var current = e && e.target;
                var next;
                if (current) {
                    var currentIndex = progress.indexOf(current);
                    if (currentIndex < progress.length) {
                        next = progress[currentIndex + 1];
                    }
                    current.classList.remove((_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active));
                    current.classList.add((_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().passed));
                }
                if (!next) {
                    progress.map(function(el) {
                        el.classList.remove((_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active));
                        el.classList.remove((_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().passed));
                    });
                    next = progress[props.currentActiveSlideIndex || 0];
                }
                next === null || next === void 0 ? void 0 : (ref = next.classList) === null || ref === void 0 ? void 0 : ref.add((_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active));
            };
            if (progress === null || progress === void 0 ? void 0 : progress.length) {
                progress.map(function(el) {
                    return el.addEventListener("animationend", playNext, false);
                });
                playNext();
            }
            return function() {
                if (progress === null || progress === void 0 ? void 0 : progress.length) {
                    progress.map(function(el) {
                        return el.removeEventListener("animationend", playNext, false);
                    });
                }
            };
        }
    }, [
        props.currentActiveSlideIndex,
        props.isAutoPlayOn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_6__/* .twMerge */ .m6)("chevronType1Container tw-pointer-events-none", "tw-relative tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-px-[40px] ".concat(showGradient ? "" : "tw-py-[24px]"), containerClass),
        children: [
            showArrows && arrowPosition === "center" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Arrows__WEBPACK_IMPORTED_MODULE_2__/* .ArrowCouple */ .l, {
                isVisible: showArrows,
                handlePrevClick: handlePrevClick,
                handleNextClick: handleNextClick,
                imageProps: props,
                arrowType: (props === null || props === void 0 ? void 0 : props.arrowType) || "v1",
                containerClass: containerClass
            }),
            showChevrons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    background: showGradient ? "linear-gradient(167.92deg, rgba(0, 0, 0, 0) 8.57%, rgba(0, 0, 0, 0.6) 90.96%)" : ""
                },
                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_6__/* .twMerge */ .m6)((_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["progress-container"]), "tw-pointer-events-auto", "tw-mt-auto tw-gap-[6px]", showGradient ? "tw-justify-center tw-h-[30px] ".concat(isMobile ? "tw-mx-[-12px] tw-w-[100vw]" : "tw-w-[680px] tw-mx-[-24px]") : ""),
                ref: progressContainerRef,
                children: [
                    showArrows && arrowPosition === "bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Arrows__WEBPACK_IMPORTED_MODULE_2__/* .ArrowIcon */ .e, {
                        onClick: handlePrevClick,
                        arrowDirection: "left",
                        arrowType: "v1",
                        imageProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                            className: "tw-mr-[10px]"
                        })
                    }),
                    props.images.map(function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_6__/* .twMerge */ .m6)((_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().progress), !props.isAutoPlayOn ? (_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().isNotAnimatable) : "", showArrows && arrowPosition === "bottom" && "tw-top-[-2.5px]", !props.isAutoPlayOn && (props.currentActiveSlideIndex === index ? (_ChevronType1_module_scss__WEBPACK_IMPORTED_MODULE_5___default().isActive) : "")),
                            style: {
                                animationDuration: chevronAnimationTiming
                            },
                            ref: function(node) {
                                return progressElementsRef.current[index] = node;
                            }
                        }, index);
                    }),
                    showArrows && arrowPosition === "bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Arrows__WEBPACK_IMPORTED_MODULE_2__/* .ArrowIcon */ .e, {
                        onClick: handleNextClick,
                        arrowDirection: "right",
                        arrowType: "v1",
                        imageProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                            className: "tw-ml-[10px]"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 932970:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progress-container":"ChevronType1_progress-container__D9ZCB","progress":"ChevronType1_progress__nq8gg","isNotAnimatable":"ChevronType1_isNotAnimatable__38i1V","isActive":"ChevronType1_isActive__gcjvg","active":"ChevronType1_active__GCHDj","Loader":"ChevronType1_Loader__Pbcv5","passed":"ChevronType1_passed___ZhZJ"};

/***/ })

}]);